export const BRAND_HISTORY_REFRESH_EVENT = "brand-history:refresh";

export const dispatchBrandHistoryRefresh = (brandId: string) => {
  if (typeof window === "undefined" || !brandId) {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(BRAND_HISTORY_REFRESH_EVENT, {
      detail: { brandId },
    })
  );
};
